// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2IjBm","buttons":"PendingPaymentAlert_buttons__ub52e"};